import React from "react";

import "leaflet/dist/leaflet.css";

import Menu3 from "./components/Menu3.js";

import withRouter from "./withRouter";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import config from "./config.js";

import { StoreContext } from "./store/RootStore";
import { observer } from "mobx-react";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import drive7Icon from "../src/assets/images/drive7.ico";
import awtlIcon from "../src/assets/images/awtl.ico";
import starlingIcon from "../src/assets/images/starling.ico";
import ctraxIcon from "../src/assets/images/ctrax.ico";
import proawtlIcon from "../src/assets/images/awtl_fav.ico";
import intellicab from "../src/assets/images/intellicab.ico";

class App extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = { collapsed: false, marginLeft: 80, settingColor: "white" };
    // console.log(props);
    // let isArabic = JSON.parse(JSON.stringify(Cookies.get())).isArabic;

    // let isSpanish = JSON.parse(JSON.stringify(Cookies.get())).isSpanish;

    let selectedLang = JSON.parse(JSON.stringify(Cookies.get()));
    // console.log(selectedLang, "asdfgh");

    // console.log(isArabic);
    // if (selectedLang) {
    //   context.setLocale("arabic");
    // } else if (isSpanish) {
    //   context.setLocale("spanish");
    // } else {
    //   context.setLocale("english");
    // }
    // isArabic ? context.setLocale("arabic") : context.setLocale("english");
  }
  handlePopState = () => {
    // For example, navigate to the login page
    this.props.navigate("/login");
  };
  async componentDidMount() {
    window.addEventListener("popstate", this.handlePopState);
  }

  updateTitle = () => {
    return config.tabTitle ? config.tabTitle : "Trackeazy"
  }

  updateIcons = () => {
    return {
      favicon: `/logos/${config.project}-favicon.ico`,
      appleTouchIcon: drive7Icon,
    };
  }


  // updateTitle = () => {
  //   if (config.project === "drive7") {
  //     return "Drive7";
  //   } else if (config.project === "awtltrack") {
  //     return "AWTL";
  //   } else if (config.project === "starlingeye") {
  //     return "Starlingeye";
  //   } else if (config.project === "trackeazy") {
  //     return "Trackeazy";
  //   } else if (config.project === "ctrax") {
  //     return "Ctrax";
  //   } else if (config.project === "proawtltrack") {
  //     return "AWTLPro";

  //   } else if (config.project === "intellicab") {
  //     return "Intellicab";
  //   } else {

  //     return "Trackeazy";
  //   }
  // };

  // updateIcons = () => {
  //   if (config.project === "drive7") {
  //     return {
  //       favicon: drive7Icon,
  //       appleTouchIcon: drive7Icon,
  //     };
  //   } else if (config.project === "awtltrack") {
  //     return {
  //       favicon: awtlIcon,
  //       appleTouchIcon: awtlIcon,
  //     };
  //   } else if (config.project === "starlingeye") {
  //     return {
  //       favicon: starlingIcon,
  //       appleTouchIcon: starlingIcon,
  //     };
  //   } else if (config.project === "trackeazy") {
  //     return {
  //       favicon: "/favicon.ico",
  //       appleTouchIcon: "/favicon.ico",
  //     };
  //   } else if (config.project === "ctrax") {
  //     return {
  //       favicon: ctraxIcon,
  //       appleTouchIcon: ctraxIcon,
  //     };
  //   } else if (config.project === "proawtltrack") {
  //     return {
  //       favicon: proawtlIcon,
  //       appleTouchIcon: proawtlIcon,
  //     };
  //   } else if (config.project === "intellicab") {
  //     return {
  //       favicon: intellicab,
  //       appleTouchIcon: intellicab,
  //     };
  //   }

  //   else {
  //     return {
  //       favicon: "/favicon.ico",
  //       appleTouchIcon: "/favicon.ico",
  //     };
  //   }
  // };
  render() {
    const { favicon, appleTouchIcon } = this.updateIcons();
    return (
      <>
        <Helmet>
          <title>{this.updateTitle()}</title>
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={appleTouchIcon} />
        </Helmet>
        <div className={config.project === "drive7" ? "drive7-wrapper" : ""}>
          {/* <Menu1 /> */}
          <Menu3 />
        </div>
      </>
    );
  }
}

// export default withRouter(App);
App.contextType = StoreContext;
export default observer(withRouter(App));
